import { EFrequencyType } from "./recurring-fee";

export * from "./recurring-fee";

export interface IJobFrequencyOption {
  value: EFrequencyType;
  label: string;
}

export const JOB_FREQUENCY_OPTIONS: IJobFrequencyOption[] = [
  { value: EFrequencyType.ONE_TIME, label: "One Time" },
  { value: EFrequencyType.DAILY, label: "Daily" },
  { value: EFrequencyType.WEEKLY, label: "Weekly" },
  { value: EFrequencyType.BY_WEEKLY, label: "Bi-Weekly" },
  { value: EFrequencyType.MONTHLY, label: "Monthly" },
  { value: EFrequencyType.BY_MONTHLY, label: "Bi-Monthly" },
  { value: EFrequencyType.QUARTERLY, label: "Quarterly" },
  { value: EFrequencyType.SEMI_ANNUALLY, label: "Semi-Annually" },
  { value: EFrequencyType.YEARLY, label: "Yearly" },
];

export const getJobFrequencyLabel = (freq?: string): string =>
  JOB_FREQUENCY_OPTIONS.find((option) => option.value === freq)?.label ?? freq ?? "Weekly";
